import { get } from 'lodash';

const styles = (theme) => ({
  "@global": {
    "#login-page-content #okta-sign-in.auth-container": {
      border: "none",
      boxShadow: "none",
      marginTop: 0,
      width: "100%",
    },
    "#login-page-content #okta-sign-in .auth-content": {
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
    "#login-page-content #okta-sign-in .auth-footer": {
      display: "none",
    },
    "#login-page-content #okta-sign-in .auth-header": {
      borderBottom: "none",
    },
    "#login-page-content #okta-sign-in .auth-org-logo": {
      height: '100px',
      maxHeight: 'none',
      maxWidth: 'none',
    },
    "#login-page-content #okta-sign-in .okta-form-title": {
      color: get(theme, 'color.bodyText'),
      fontSize: 34,
      fontFamily: get(theme, 'typography.pageTitle'),
    },
    "#login-page-content #okta-sign-in .button-primary": {
      background: 'none',
      backgroundColor: get(theme, 'color.primaryButtonBackground'),
      borderColor: 'none',
      boxShadow: "none",
    },
    "#login-page-content #okta-sign-in .o-form-button-bar": {
      paddingBottom: 0,
    },
    "#login-page-content #okta-sign-in input[type=text]:focus": {
      boxShadow: 'none',
    },
  },
  okta: {
    h1: {
      fontSize: '34px',
      fontFamily: 'open-sans-bold',

      img: {
        marginTop: '-5px',
      },
    },
    form: {
      margin: 0,
    },
  },
});

export default styles;